/**
 * @generated SignedSource<<94d29a4626a91609b581ee13811e980e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type incomeCurvesPage_DetailQuery$variables = {
  signupMonth: string;
  tenureMonths: number;
};
export type incomeCurvesPage_DetailQuery$data = {
  readonly incomeCohortDetail: {
    readonly invoices: ReadonlyArray<{
      readonly amount: number;
      readonly daysAfterSignup: number;
      readonly stripeId: string;
      readonly subscription: boolean;
    }>;
    readonly paygTotal: number;
    readonly signupMonth: string;
    readonly subscriptionTotal: number;
    readonly tenureMonths: number;
    readonly total: number;
  };
};
export type incomeCurvesPage_DetailQuery = {
  response: incomeCurvesPage_DetailQuery$data;
  variables: incomeCurvesPage_DetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signupMonth"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenureMonths"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "signupMonth",
    "variableName": "signupMonth"
  },
  {
    "kind": "Variable",
    "name": "tenureMonths",
    "variableName": "tenureMonths"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupMonth",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tenureMonths",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionTotal",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paygTotal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripeId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysAfterSignup",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscription",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "incomeCurvesPage_DetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IncomeCohortDetail",
        "kind": "LinkedField",
        "name": "incomeCohortDetail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IncomeInvoice",
            "kind": "LinkedField",
            "name": "invoices",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "incomeCurvesPage_DetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IncomeCohortDetail",
        "kind": "LinkedField",
        "name": "incomeCohortDetail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IncomeInvoice",
            "kind": "LinkedField",
            "name": "invoices",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4741fee4080c8db1f3aac4cfdc06cd4e",
    "id": null,
    "metadata": {},
    "name": "incomeCurvesPage_DetailQuery",
    "operationKind": "query",
    "text": "query incomeCurvesPage_DetailQuery(\n  $signupMonth: String!\n  $tenureMonths: Int!\n) {\n  incomeCohortDetail(signupMonth: $signupMonth, tenureMonths: $tenureMonths) {\n    signupMonth\n    tenureMonths\n    total\n    subscriptionTotal\n    paygTotal\n    invoices {\n      stripeId\n      daysAfterSignup\n      amount\n      subscription\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0565e03d9f8b8bb4b1521b965851ef8";

export default node;
